/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeMountedMaterialSequenceEntry } from '../../models/change-mounted-material-sequence-entry';

export interface ChangeMountedMaterialSequence$Params {
  materialBlockId: number;
      body: ChangeMountedMaterialSequenceEntry
}

export function changeMountedMaterialSequence(http: HttpClient, rootUrl: string, params: ChangeMountedMaterialSequence$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, changeMountedMaterialSequence.PATH, 'post');
  if (params) {
    rb.path('materialBlockId', params.materialBlockId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

changeMountedMaterialSequence.PATH = '/api/v1/PrimaryMaterial/{materialBlockId}/ChangeMountedMaterialSequence';
